import { z } from 'zod'
import { listResponseSchema } from '@/core/types/ListResponse.ts'
import { responseSchema } from '@/core/types/Response.ts'

export const notificationSchema = z.object({
  id: z.string(),
  message: z.string(),
  requestReference: z.string(),
  requestId: z.string(),
  requestStatus: z.string(),
  requestType: z.string(),
  createdBy: z.string(),
  createdAt: z.string()
})

export const NotificationListResponseSchema =
  listResponseSchema(notificationSchema)

export const NotificationResponseSchema = responseSchema(
  z.object({
    last: z.array(notificationSchema),
    unread: z.number()
  })
)

export type Notification = z.infer<typeof notificationSchema>

export type NotificationListResponse = z.infer<
  typeof NotificationListResponseSchema
>

export type NotificationResponse = z.infer<typeof NotificationResponseSchema>
